module.exports = __webpack_public_path__ + "048494bd045fc6ca2a665c215391c961.svg";